import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Button, CardBody, Card, Input } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import WebapiCommon from '@common/util/webapi.common';
import { enumFiltroTipo, enumFiltroTipoExam } from '@common/util/defaultValues';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';
import * as commonActions from '../../../../app/common/common.action';
import { useDispatch } from 'react-redux';

function Filtro({
  filtro,
  setFiltro,
  filtrar,
}) {
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const medicos = useSelector(state => state.commonReducer.medicos);
  const [tiposExame, setTiposExame] = useState([]);
  const [medicosFiltro, setMedicosFiltro] = useState([]);
  const intl = useIntl();
  const dispatch = useDispatch();
  const [periodo, setPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });
	const periodos = obterListagemDePeriodos(intl);

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  useEffect(() => {
    const datas = CommonFunctions.getPeriodosSubDays(0);
    const { periodoInicial, periodoFinal } = datas;

    setFiltro({ periodoInicial, periodoFinal });
    loadItensFiltro();
    setMedicosFiltro([{ label: <IntlMessage id="dashboards.reports.all" />, value: null }, ...medicos]);
  }, [medicos]);

  const onChangeTipoFiltro = item => {
    setFiltro({ ...filtro, tipo: item.value });

    //if (item.value.indexOf('dt') < 0)
    //  resetarPeriodo();
  };

  const loadItensFiltro = async () => {
    try {
      const response = await WebapiCommon.getTiposExame();
      setTiposExame(response);
    } catch (error) { }
  };

  const showInput = tipo => {
    switch (tipo) {
      case enumFiltroTipo.NR_EXAME:
      case enumFiltroTipo.NOME_PACIENTE:
      case enumFiltroTipo.OBSERVACAO_LAUDO:
        return true;
      default:
        return false;
    }
  };

	function resetarPeriodo() {
		setPeriodo('');
    setFiltro({ ...filtro, periodoInicial: null, periodoFinal: null });
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setPeriodo(e);
    setFiltro({ ...filtro, periodoInicial: payload.dtinicial, periodoFinal: payload.dtfinal });
	}

	function mudarIntervaloPeriodo(val) {
		let payload = changePeriod(val);

    setFiltro({ ...filtro, periodoInicial: payload.start, periodoFinal: payload.end });
	}

  function eventoOnKeyPressData(event) {
		if (event.key === "Enter") {
      const result = CommonFunctions.validaData(filtro.periodoInicial, filtro.periodoFinal, intl);

      if (!result.valid) {
        dispatch(commonActions.showAlerta('alerta', result.message, 3000));
        return;
      }

			filtrar(filtro);
    }
	}

  return (
    <Card>
      <CardBody>
        <Row>
          {<Col sm={'3'}>
            <SelectComponent
              options={medicosFiltro}
              onChange={event => setFiltro({ ...filtro, medico: event.value })}
              placeholder={translate("general.requestsPanel.doctorResponsible")}
              styles={{ borderColor: 'transparent' }}
              disabled={carregando}
            />
          </Col>}
          <Col sm={'2'}>
            <SelectComponent
              options={enumFiltroTipoExam}
              onChange={item => onChangeTipoFiltro(item)}
              placeholder={translate("general.requestsPanel.searchType")}
              styles={{ borderColor: 'transparent' }}
              disabled={carregando}
            />
          </Col>
          <Col
            sm={'auto'}
            style={{
              padding: 0,
              display:
                filtro.tipo !== enumFiltroTipo.DATA_ENTREGA &&
                  filtro.tipo !== enumFiltroTipo.DATA_SOLICITACAO
                  ? 'none'
                  : 'initial'
            }}
          >
            <Row style={{ marginRight: '15px' }}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
                <div className="label-data"><IntlMessage id="period.name"/></div>
                <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
                  <SelectComponent
                    isClearable
                    className="filtro-data"
                    noOptionsMessage={() => {
                    return intl.formatMessage({id: "dashboards.reports.noItemsFound"});
                    }}
                    name="form-field-period"
                    placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
                    value={periodo}
                    onChange={(e) => {
                    periodoAlterado(e);
                    e && e.value ? mudarIntervaloPeriodo(e.value) : mudarIntervaloPeriodo('todos');
                    }}
                    options={periodos}
                  />
                </div>

                {periodo && periodo.value === 'outro' && (
                  <React.Fragment>
                    <DebounceInput
                    name="periodoDe"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filtro.periodoInicial}
                    onChange={e => setFiltro({ ...filtro, periodoInicial: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                    <DebounceInput
                    name="periodoAte"
                    type="date"
                    style={{width: '130px', display: 'block'}}
                    className="filtro-data"
                    value={filtro.periodoFinal}
                    onChange={e => setFiltro({ ...filtro, periodoFinal: e.target.value })}
                    onKeyPress={(e) => eventoOnKeyPressData(e)}
                    />
                  </React.Fragment>
                )}
              </div>
            </Row>
          </Col>
          <Col
            sm={'1'}
            style={{
              display: showInput(filtro.tipo) ? 'initial' : 'none'
            }}
          >
            <Input
              style={{
                height: '45px',
                borderRadius: '5px',
                fontSize: '13px'
              }}
              type={'text'}
              onChange={event =>
                setFiltro({ ...filtro, value: event.target.value })
              }
              disabled={carregando}
            />
          </Col>
          <Col sm={1}>
            <Button
              className='btn btn-primary'
              onClick={() => filtrar(filtro)}
              style={{ height: '38px', width: '38px' }}
              disabled={carregando || !filtro.tipo}
            >
              <i className='icons-btn mv-basico-pesquisar'></i>
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>);
}

export default Filtro;


// WEBPACK FOOTER //
// ./src/pages/relatorio/Faturamento/Filtro/index.js